"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlForUpload = urlForUpload;
var _env = require("./env");
function urlForUpload(upload) {
  var id = upload.id || upload;
  return "".concat(_env.API_URL, "/1/uploads/").concat(id, "/raw");
}